import { useState } from "react"
import IdleTimer from "react-idle-timer"

export default function IdleTimeCalculator() {
    const { VITE_APP_PRODUCT_HUB } = import.meta.env

    const [idleTimer, setIdleTimer] = useState({
        idleTimer: null,
    })

    const actualTimeOut = 1000 * 60 * 15

    const handleOnIdle = () => {
        localStorage.clear()
        // Trigger logout event across tabs
        localStorage.setItem("logoutEvent", Date.now())

        setTimeout(() => {
            window.location.href = VITE_APP_PRODUCT_HUB
        }, 500)
    }

    const handleOnActive = () => {
        idleTimer.getRemainingTime()
    }

    const handleOnAction = () => {}

    return (
        <IdleTimer
            ref={(ref) => {
                setIdleTimer(ref)
            }}
            element={document}
            onActive={handleOnActive}
            onIdle={handleOnIdle}
            onAction={handleOnAction}
            debounce={250}
            timeout={actualTimeOut}
        />
    )
}
